import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
    ACTIVE_STATUS,
    LEAD_STATUS,
    LEAD_STATUS_DEAL_CLOSED,
    TASK_STATUS,
    TASK_STATUS_CANCELLED,
    TASK_STATUS_CLOSED,
} from '../../../Utility/constant';


const useFilteredCallerData = (callerContext, showOpenLeadsOnly, showOpenTasksOnly) => {

    const lookupData = useSelector((state) => state?.lookup?.lookupData);
 
    const leadStatusData = useMemo(() => {
        return lookupData
            ?.find((item) => item?.name === LEAD_STATUS)?.codes
            ?.filter((item) => item?.status === ACTIVE_STATUS)
            ?.sort((a, b) => a?.sequence - b?.sequence);
    }, [lookupData]);

    const taskStatusData = useMemo(() => {
        return lookupData
            ?.find((item) => item?.name === TASK_STATUS)?.codes
            ?.filter((item) => item?.status === ACTIVE_STATUS)
            ?.sort((a, b) => a?.sequence - b?.sequence);
    }, [lookupData]);

    const displayedLeads = useMemo(() => {
        const allLeads = callerContext?.leads || [];
        if (!showOpenLeadsOnly) return allLeads;

        return allLeads.filter((lead) => {
            const matchedStatus = leadStatusData?.find((item) => item?.name === lead?.status);
            const isDealClosedOrCancelled =
                matchedStatus?.systemLookupCode?.name === LEAD_STATUS_DEAL_CLOSED ||
                matchedStatus?.systemLookupCode?.name === 'LEAD_STATUS_CANCELLED';
            return !isDealClosedOrCancelled;
        });
    }, [callerContext?.leads, leadStatusData, showOpenLeadsOnly]);

    const displayedTasks = useMemo(() => {
        const allTasks = callerContext?.tasks || [];
        if (!showOpenTasksOnly) return allTasks;

        return allTasks.filter((task) => {
            const matchedStatus = taskStatusData?.find((item) => item?.name === task?.status);
            const isClosedOrCancelled =
                matchedStatus?.systemLookupCode?.name === TASK_STATUS_CLOSED ||
                matchedStatus?.systemLookupCode?.name === TASK_STATUS_CANCELLED;
            return !isClosedOrCancelled;
        });
    }, [callerContext?.tasks, taskStatusData, showOpenTasksOnly]);

    return { displayedLeads, displayedTasks };
};

export default useFilteredCallerData;
